import React, { useContext } from "react";

import ContentEncoder from "./ContentEncoder";
import ContentContext from "../../contexts/ContentContext";

import type { JSX } from "react";

import type { GetMediaResponse, MediaChildren } from "../../api/MediaAPI.types";

export default function ContentHosted(): JSX.Element {
  const { item } = useContext<{
    item: GetMediaResponse | MediaChildren;
    onItemUpdate: (updatedItem: GetMediaResponse | MediaChildren) => void;
  }>(ContentContext);

  return <ContentEncoder item={item} />;
}
